import * as type from './constant';

export const getWorkTimeStandard = (params = undefined, selfRole = undefined) => ({
  type: type.GET,
  params,
  selfRole,
});

export const getWorkTimeStandardSuccess = (payload) => ({
  type: type.GET_SUCCESS,
  payload,
});

export const getWorkTimeStandardError = (error) => ({
  type: type.GET_ERROR,
  error,
});

export const addWorkTimeStandard = (payload, selfRole = undefined) => ({
  type: type.ADD,
  payload,
  selfRole
});

export const addWorkTimeStandardSuccess = (payload) => ({
  type: type.ADD_SUCCESS,
  payload,
});

export const updateWorkTimeStandard = (id, payload, selfRole = undefined) => ({
  type: type.UPDATE,
  id,
  payload,
  selfRole,
});

export const updateWorkTimeStandardSuccess = (payload) => ({
  type: type.UPDATE_SUCCESS,
  payload,
});

export const deleteWorkTimeStandard = (ids, selfRole = undefined) => ({
  type: type.DELETE,
  ids,
  selfRole,
});

export const deleteWorkTimeStandardSuccess = (payload) => ({
  type: type.DELETE_SUCCESS,
  payload,
});

export const manipulationWorkTimeStandardError = (error) => ({
  type: type.MANIPULATION_ERROR,
  error,
});
